// Version configuration for the application
export const APP_VERSION = '1.4.0';
export const APP_BUILD_DATE = '2026-02-05';

export const VERSION_HISTORY = [
  { version: '1.4.0', date: '2026-02-05', changes: ['Sélecteur période planning', 'Lignes vides fines', 'Étoile jaune clignotante', 'Journal erreurs'] },
  { version: '1.3.0', date: '2026-02-04', changes: ['Copie conforme site public', 'Module Communication P0', 'Drag&Drop Planning P1'] },
  { version: '1.2.0', date: '2026-02-03', changes: ['Planning horizontal', 'Gestion congés N-1', 'Annulation absences'] },
  { version: '1.1.0', date: '2026-02-02', changes: ['Reporting Planning', 'Administration avancée'] },
  { version: '1.0.0', date: '2026-02-01', changes: ['Version initiale', 'Authentification', 'Planning', 'Absences'] },
];
